import React, { FC, useContext } from "react";
import styles from "./Rodape.module.scss";
import Logo from "./../../../Static/Images/QUEROVET - LOGO BRANCO.png";
import { Link } from "react-scroll";
import SetaMenu from "./../../../Static/Images/seta_menu.png";
import { MenuItems } from "../TopBar";
import Instagram from "./../../../Static/Images/Icones/Instagram.png";
import Apple from "./../../../Static/Images/Icones/Apple.png";
import Facebook from "./../../../Static/Images/Icones/Facebook.png";
import Youtube from "./../../../Static/Images/Icones/Play_.png";
import PlayStore from "./../../../Static/Images/Icones/Play-store.png";
import { TermoContext } from "../../../Context/Termos/Termo.Provider";

export const Rodape: FC = () => {
  const termoContext = useContext(TermoContext);

  return (
    <div className={styles["Rodape"]}>
      <div className={styles["Item"]}>
        <img alt="Logo Quero Vet" src={Logo} className={styles["Logo"]} />
        <div className={styles["Social"]}>
          {process.env.REACT_APP_YT_URL && (
            <a href={process.env.REACT_APP_YT_URL} target="_BLANK">
              <img src={Youtube} />
            </a>
          )}
          {process.env.REACT_APP_FB_URL && (
            <a href={process.env.REACT_APP_FB_URL} target="_BLANK">
              <img src={Facebook} />
            </a>
          )}
          {process.env.REACT_APP_INSTAGRAM_URL && (
            <a href={process.env.REACT_APP_INSTAGRAM_URL} target="_BLANK">
              <img src={Instagram} />
            </a>
          )}
        </div>
        <div className={styles["Download"]}>
          <span>Baixe o nosso app</span>
          <a href={process.env.REACT_APP_ANDROID_URL} target="_BLANK">
            <img src={PlayStore} />
          </a>
          <a href={process.env.REACT_APP_IOS_URL} target="_BLANK">
            <img src={Apple} />
          </a>
        </div>
      </div>
      <div className={styles["Item"]}>
        <span className={styles["Title-Menu"]}>Institucional</span>
        {MenuItems.filter((x) => x.to !== "perguntasfrequentes").map(
          (item, idx) => {
            return (
              <Link
                activeClass="active"
                to={item.to}
                key={`item-menu-rodape-${idx}`}
                spy={true}
                smooth={true}
                duration={500}
              >
                <img
                  alt="Seta"
                  className={styles["Item-Seta"]}
                  src={SetaMenu}
                />
                <span className={styles["Item-Menu"]}> {item.label}</span>
              </Link>
            );
          }
        )}
      </div>
      <div className={styles["Item"]}>
        <span className={styles["Title-Menu"]}>Informações</span>
        <a
          onClick={() =>
            termoContext.effects &&
            termoContext.effects.getTermo("termos-de-uso-vet-saude")
          }
        >
          <img alt="Seta" className={styles["Item-Seta"]} src={SetaMenu} />
          <span className={styles["Item-Menu"]}>
            Termos de Adesão Vet Saúde
          </span>
        </a>
        <a
          onClick={() =>
            termoContext.effects &&
            termoContext.effects.getTermo("termos-de-uso-usuario")
          }
        >
          <img alt="Seta" className={styles["Item-Seta"]} src={SetaMenu} />
          <span className={styles["Item-Menu"]}>
            Termos de Uso para Usuários
          </span>
        </a>
        <a
          onClick={() =>
            termoContext.effects &&
            termoContext.effects.getTermo("termos-de-uso-veterinario")
          }
        >
          <img alt="Seta" className={styles["Item-Seta"]} src={SetaMenu} />
          <span className={styles["Item-Menu"]}>
            Termos de Uso para Veterinários
          </span>
        </a>
        <a
          onClick={() =>
            termoContext.effects &&
            termoContext.effects.getTermo("politica-de-privacidade")
          }
        >
          <img alt="Seta" className={styles["Item-Seta"]} src={SetaMenu} />
          <span className={styles["Item-Menu"]}>Política de Privacidade</span>
        </a>
        <Link
          activeClass="active"
          to={"perguntasfrequentes"}
          key={`item-menu-rodape-perguntas-freq`}
          spy={true}
          smooth={true}
          duration={500}
        >
          <img alt="Seta" className={styles["Item-Seta"]} src={SetaMenu} />
          <span className={styles["Item-Menu"]}> Perguntas Frequentes</span>
        </Link>
        <Link
          activeClass="active"
          to={"facaParteTimeQueroVet"}
          key={`item-menu-rodape-go-time-querovet`}
          spy={true}
          smooth={true}
          duration={500}
        >
          <img alt="Seta" className={styles["Item-Seta"]} src={SetaMenu} />
          <span className={styles["Item-Menu"]}>
            Faça Parte do Time QueroVet
          </span>
        </Link>
      </div>
      <div className={`${styles["Item"]} ${styles["Item-Atendimento"]}`}>
        <span className={styles["Title-Menu"]}>Atendimento</span>
        <div className={styles["Group"]}>
          <span className={styles["Text"]}>Telefone</span>
          <a
            target="_BLANK"
            rel="noreferrer"
            href="https://api.whatsapp.com/send?phone=5564999686677&text=Olá%2C%20quero%20saber%20mais%20sobre%20a%20Quero%20Vet"
            className={styles["Text"]}
          >
            <span>64.</span>98458-4426
          </a>
        </div>
        <div className={styles["Group"]}>
          <span className={styles["Text"]}>Email</span>
          <a href="mailto:contato@querovet.com.br" className={styles["Text"]}>
            contato@querovet.com.br
          </a>
        </div>
      </div>
    </div>
  );
};
